/** @jsxRuntime classic */
export default function PresentedBrands() {
  // Don't show any presented brands because this is a winery site.
  return null;
}
